export const translations = {
  fr: {
    nav: {
      properties: "Immobilier",
      services: "Conciergerie",
      contact: "Contact"
    },
    hero: {
      overline: "Immobilier & Conciergerie à Bali",
      title: "Découvrez Bali.",
      subtitle: "Projets immobiliers exclusifs et services de conciergerie haut de gamme sur l'île des Dieux.",
      cta: "Découvrir le Projet Immobilier",
      chatCta: "Parler à un Expert",
      stats: {
        yield: "Rendement moyen",
        tax: "Taxe sur les gains",
        project: "Kaba-Kaba",
        projectName: "x Bali Life"
      }
    },
    whyBali: {
      overline: "L'Avantage Bali",
      title: "Pourquoi Bali",
      subtitle: "Découvrez pourquoi Bali est la destination privilégiée pour l'investissement immobilier de luxe.",
      cards: {
        yields: {
          title: "Rendements Élevés",
          subtitle: "12-16% Rendement",
          description: "Des rendements locatifs exceptionnels grâce au tourisme de luxe en plein essor."
        },
        growth: {
          title: "Croissance Continue",
          subtitle: "Marché Stable",
          description: "Un marché immobilier en croissance constante avec une demande internationale forte."
        },
        tax: {
          title: "Avantages Fiscaux",
          subtitle: "Optimisation",
          description: "Structure fiscale avantageuse pour les investisseurs internationaux."
        }
      }
    },
    properties: {
      overline: "Opportunités Immobilières",
      title: "Propriétés Exclusives",
      filters: {
        all: "Tous",
        villas: "Villas",
        apartments: "Appartements"
      },
      status: {
        available: "Disponible",
        reserved: "Réservé",
        sold: "Vendu"
      },
      yield: "Rendement",
      completion: "Livraison",
      viewDetails: "Voir détails",
      noResults: "Aucun bien trouvé"
    },
    services: {
      overline: "Services Exclusifs",
      title: "Conciergerie de Luxe",
      subtitle: "Une gamme complète de services haut de gamme pour une expérience balinaise inoubliable.",
      items: {
        vip: {
          title: "Transferts VIP & Hélicoptère",
          description: "Accueil aéroport, chauffeur privé et transferts en hélicoptère."
        },
        villa: {
          title: "Gestion de Villas",
          description: "Service complet de gestion locative et d'entretien pour votre propriété."
        },
        chef: {
          title: "Chef Privé & Wellness",
          description: "Expériences gastronomiques sur mesure et soins spa à domicile."
        },
        yacht: {
          title: "Yacht & Excursions",
          description: "Location de yachts privés et organisation d'excursions exclusives."
        }
      }
    },
    journey: {
      overline: "Votre Parcours",
      title: "Comment Ça Marche",
      steps: {
        consultation: {
          title: "Consultation",
          description: "Nous définissons vos objectifs d'investissement et votre style de vie."
        },
        selection: {
          title: "Sélection",
          description: "Portfolio de propriétés correspondant à vos critères."
        },
        acquisition: {
          title: "Acquisition",
          description: "Gestion complète de la transaction jusqu'à la remise des clés."
        },
        handover: {
          title: "Gestion",
          description: "Services de conciergerie et gestion locative inclus."
        }
      }
    },
    testimonials: {
      overline: "Témoignages",
      title: "Ce Que Disent Nos Clients",
      items: {
        sophie: {
          role: "Client, Paris",
          text: "Un accompagnement exceptionnel du début à la fin. Mon investissement génère un rendement supérieur à mes attentes."
        },
        thomas: {
          role: "Entrepreneur, Lyon",
          text: "Professionnalisme et expertise remarquables. Bali Life a rendu mon achat simple et sécurisé."
        },
        marie: {
          role: "Expat, Singapour",
          text: "La qualité des services de conciergerie est incomparable. Une équipe vraiment dévouée."
        }
      }
    },
    contact: {
      overline: "Commencer",
      title: "Parlons de Votre Projet",
      subtitle: "Notre équipe d'experts est à votre disposition pour répondre à toutes vos questions sur l'investissement à Bali.",
      info: {
        address: { title: "Adresse" },
        phone: { title: "Téléphone" },
        email: { title: "Email" }
      },
      form: {
        name: "Nom complet",
        namePlaceholder: "Votre nom",
        email: "Email",
        emailPlaceholder: "vous@email.com",
        phone: "Téléphone",
        phonePlaceholder: "+33 6 00 00 00 00",
        message: "Message",
        messagePlaceholder: "Comment pouvons-nous vous aider ?",
        send: "Envoyer",
        sending: "Envoi..."
      },
      success: {
        title: "Message Envoyé !",
        message: "Notre équipe vous contactera sous 24h."
      }
    },
    footer: {
      description: "Votre partenaire de confiance pour l'investissement immobilier et les services de conciergerie de luxe à Bali.",
      quickLinks: "Navigation",
      followUs: "Suivez-nous",
      rights: "Tous droits réservés."
    },
    chatbot: {
      title: "Concierge IA",
      subtitle: "En ligne 24/7",
      welcome: "Bonjour ! Je suis votre concierge IA. Comment puis-je vous aider avec votre projet d'investissement ou de séjour à Bali ?",
      placeholder: "Écrivez votre message...",
      error: "Désolé, une erreur s'est produite. Veuillez réessayer."
    }
  },
  en: {
    nav: {
      properties: "Real Estate",
      services: "Concierge",
      contact: "Contact"
    },
    hero: {
      overline: "Real Estate & Concierge in Bali",
      title: "Discover the Extraordinary.",
      subtitle: "Exclusive real estate projects and premium concierge services on the Island of Gods.",
      cta: "Discover the Real Estate Project",
      chatCta: "Talk to an Expert",
      stats: {
        yield: "Average Yield",
        tax: "Capital Gains Tax",
        project: "Kaba-Kaba",
        projectName: "x Bali Life"
      }
    },
    whyBali: {
      overline: "The Bali Advantage",
      title: "Why Bali",
      subtitle: "Discover why Bali is the premier destination for luxury real estate.",
      cards: {
        yields: {
          title: "High Yields",
          subtitle: "12-16% Yield",
          description: "Exceptional rental yields thanks to the booming luxury tourism sector."
        },
        growth: {
          title: "Steady Growth",
          subtitle: "Stable Market",
          description: "A consistently growing real estate market with strong international demand."
        },
        tax: {
          title: "Tax Benefits",
          subtitle: "Optimization",
          description: "Advantageous tax structure for international investors."
        }
      }
    },
    properties: {
      overline: "Real Estate Opportunities",
      title: "Exclusive Properties",
      filters: {
        all: "All",
        villas: "Villas",
        apartments: "Apartments"
      },
      status: {
        available: "Available",
        reserved: "Reserved",
        sold: "Sold"
      },
      yield: "Yield",
      completion: "Completion",
      viewDetails: "View details",
      noResults: "No properties found"
    },
    services: {
      overline: "Exclusive Services",
      title: "Luxury Concierge",
      subtitle: "A comprehensive range of premium services for an unforgettable Bali experience.",
      items: {
        vip: {
          title: "VIP Transfers & Helicopter",
          description: "Airport welcome, private driver and helicopter transfers."
        },
        villa: {
          title: "Villa Management",
          description: "Complete rental management and maintenance service for your property."
        },
        chef: {
          title: "Private Chef & Wellness",
          description: "Bespoke culinary experiences and in-home spa treatments."
        },
        yacht: {
          title: "Yacht & Excursions",
          description: "Private yacht rentals and exclusive excursion planning."
        }
      }
    },
    journey: {
      overline: "Your Journey",
      title: "How It Works",
      steps: {
        consultation: {
          title: "Consultation",
          description: "We define your investment goals and lifestyle needs."
        },
        selection: {
          title: "Selection",
          description: "Curated portfolio of properties matching your criteria."
        },
        acquisition: {
          title: "Acquisition",
          description: "Complete transaction management until handover."
        },
        handover: {
          title: "Management",
          description: "Concierge services and rental management included."
        }
      }
    },
    testimonials: {
      overline: "Testimonials",
      title: "What Our Clients Say",
      items: {
        sophie: {
          role: "Client, Paris",
          text: "Exceptional support from start to finish. My investment generates returns above expectations."
        },
        thomas: {
          role: "Entrepreneur, Lyon",
          text: "Remarkable professionalism and expertise. Bali Life made my purchase simple and secure."
        },
        marie: {
          role: "Expat, Singapore",
          text: "The quality of concierge services is unparalleled. A truly dedicated team."
        }
      }
    },
    contact: {
      overline: "Get Started",
      title: "Let's Discuss Your Project",
      subtitle: "Our team of experts is available to answer all your questions about investing in Bali.",
      info: {
        address: { title: "Address" },
        phone: { title: "Phone" },
        email: { title: "Email" }
      },
      form: {
        name: "Full name",
        namePlaceholder: "Your name",
        email: "Email",
        emailPlaceholder: "you@email.com",
        phone: "Phone",
        phonePlaceholder: "+1 234 567 8900",
        message: "Message",
        messagePlaceholder: "How can we help you?",
        send: "Send",
        sending: "Sending..."
      },
      success: {
        title: "Message Sent!",
        message: "Our team will contact you within 24h."
      }
    },
    footer: {
      description: "Your trusted partner for real estate investment and luxury concierge services in Bali.",
      quickLinks: "Navigation",
      followUs: "Follow Us",
      rights: "All rights reserved."
    },
    chatbot: {
      title: "AI Concierge",
      subtitle: "Online 24/7",
      welcome: "Hello! I'm your AI concierge. How can I help you with your investment or stay in Bali?",
      placeholder: "Write your message...",
      error: "Sorry, an error occurred. Please try again."
    }
  },
  id: {
    nav: {
      properties: "Properti",
      services: "Concierge",
      contact: "Kontak"
    },
    hero: {
      overline: "Properti & Concierge di Bali",
      title: "Temukan yang Luar Biasa.",
      subtitle: "Proyek properti eksklusif dan layanan concierge premium di Pulau Dewata.",
      cta: "Temukan Proyek Properti",
      chatCta: "Bicara dengan Ahli",
      stats: {
        yield: "Yield Rata-rata",
        tax: "Pajak Capital Gain",
        project: "Kaba-Kaba",
        projectName: "x Bali Life"
      }
    },
    whyBali: {
      overline: "Keunggulan Bali",
      title: "Mengapa Bali",
      subtitle: "Temukan mengapa Bali adalah destinasi utama untuk properti mewah.",
      cards: {
        yields: {
          title: "Yield Tinggi",
          subtitle: "12-16% Yield",
          description: "Yield sewa luar biasa berkat sektor pariwisata mewah yang berkembang."
        },
        growth: {
          title: "Pertumbuhan Stabil",
          subtitle: "Pasar Stabil",
          description: "Pasar properti yang terus tumbuh dengan permintaan internasional yang kuat."
        },
        tax: {
          title: "Keuntungan Pajak",
          subtitle: "Optimisasi",
          description: "Struktur pajak yang menguntungkan untuk investor internasional."
        }
      }
    },
    properties: {
      overline: "Peluang Properti",
      title: "Properti Eksklusif",
      filters: {
        all: "Semua",
        villas: "Villa",
        apartments: "Apartemen"
      },
      status: {
        available: "Tersedia",
        reserved: "Dipesan",
        sold: "Terjual"
      },
      yield: "Yield",
      completion: "Selesai",
      viewDetails: "Lihat detail",
      noResults: "Tidak ada properti"
    },
    services: {
      overline: "Layanan Eksklusif",
      title: "Concierge Mewah",
      subtitle: "Rangkaian lengkap layanan premium untuk pengalaman Bali yang tak terlupakan.",
      items: {
        vip: {
          title: "Transfer VIP & Helikopter",
          description: "Sambutan bandara, sopir pribadi dan transfer helikopter."
        },
        villa: {
          title: "Manajemen Villa",
          description: "Layanan manajemen sewa dan perawatan lengkap untuk properti Anda."
        },
        chef: {
          title: "Chef Pribadi & Wellness",
          description: "Pengalaman kuliner khusus dan perawatan spa di rumah."
        },
        yacht: {
          title: "Yacht & Ekskursi",
          description: "Sewa yacht pribadi dan perencanaan ekskursi eksklusif."
        }
      }
    },
    journey: {
      overline: "Perjalanan Anda",
      title: "Cara Kerjanya",
      steps: {
        consultation: {
          title: "Konsultasi",
          description: "Kami menentukan tujuan investasi dan kebutuhan gaya hidup Anda."
        },
        selection: {
          title: "Seleksi",
          description: "Portofolio properti yang sesuai dengan kriteria Anda."
        },
        acquisition: {
          title: "Akuisisi",
          description: "Manajemen transaksi lengkap hingga serah terima."
        },
        handover: {
          title: "Manajemen",
          description: "Layanan concierge dan manajemen sewa termasuk."
        }
      }
    },
    testimonials: {
      overline: "Testimoni",
      title: "Apa Kata Klien Kami",
      items: {
        sophie: {
          role: "Client, Paris",
          text: "Dukungan luar biasa dari awal hingga akhir. Investasi saya menghasilkan pengembalian di atas ekspektasi."
        },
        thomas: {
          role: "Pengusaha, Lyon",
          text: "Profesionalisme dan keahlian yang luar biasa. Bali Life membuat pembelian saya sederhana dan aman."
        },
        marie: {
          role: "Ekspat, Singapura",
          text: "Kualitas layanan concierge tidak tertandingi. Tim yang benar-benar berdedikasi."
        }
      }
    },
    contact: {
      overline: "Mulai",
      title: "Mari Diskusikan Proyek Anda",
      subtitle: "Tim ahli kami siap menjawab semua pertanyaan Anda tentang investasi di Bali.",
      info: {
        address: { title: "Alamat" },
        phone: { title: "Telepon" },
        email: { title: "Email" }
      },
      form: {
        name: "Nama lengkap",
        namePlaceholder: "Nama Anda",
        email: "Email",
        emailPlaceholder: "anda@email.com",
        phone: "Telepon",
        phonePlaceholder: "+62 812 345 6789",
        message: "Pesan",
        messagePlaceholder: "Bagaimana kami bisa membantu?",
        send: "Kirim",
        sending: "Mengirim..."
      },
      success: {
        title: "Pesan Terkirim!",
        message: "Tim kami akan menghubungi Anda dalam 24 jam."
      }
    },
    footer: {
      description: "Mitra terpercaya Anda untuk investasi properti dan layanan concierge mewah di Bali.",
      quickLinks: "Navigasi",
      followUs: "Ikuti Kami",
      rights: "Hak cipta dilindungi."
    },
    chatbot: {
      title: "Concierge AI",
      subtitle: "Online 24/7",
      welcome: "Halo! Saya concierge AI Anda. Bagaimana saya bisa membantu dengan investasi atau liburan Anda di Bali?",
      placeholder: "Tulis pesan Anda...",
      error: "Maaf, terjadi kesalahan. Silakan coba lagi."
    }
  },
  es: {
    nav: {
      properties: "Inmobiliario",
      services: "Conserjería",
      contact: "Contacto"
    },
    hero: {
      overline: "Inmobiliario y Conserjería en Bali",
      title: "Descubre lo Extraordinario.",
      subtitle: "Proyectos inmobiliarios exclusivos y servicios de conserjería premium en la Isla de los Dioses.",
      cta: "Descubrir el Proyecto Inmobiliario",
      chatCta: "Hablar con un Experto",
      stats: {
        yield: "Rendimiento medio",
        tax: "Impuesto ganancias",
        project: "Kaba-Kaba",
        projectName: "x Bali Life"
      }
    },
    whyBali: {
      overline: "La Ventaja Bali",
      title: "Por Qué Bali",
      subtitle: "Descubre por qué Bali es el destino principal para el inmobiliario de lujo.",
      cards: {
        yields: {
          title: "Altos Rendimientos",
          subtitle: "12-16% Rendimiento",
          description: "Rendimientos de alquiler excepcionales gracias al auge del turismo de lujo."
        },
        growth: {
          title: "Crecimiento Estable",
          subtitle: "Mercado Estable",
          description: "Un mercado inmobiliario en constante crecimiento con fuerte demanda internacional."
        },
        tax: {
          title: "Beneficios Fiscales",
          subtitle: "Optimización",
          description: "Estructura fiscal ventajosa para inversores internacionales."
        }
      }
    },
    properties: {
      overline: "Oportunidades Inmobiliarias",
      title: "Propiedades Exclusivas",
      filters: {
        all: "Todos",
        villas: "Villas",
        apartments: "Apartamentos"
      },
      status: {
        available: "Disponible",
        reserved: "Reservado",
        sold: "Vendido"
      },
      yield: "Rendimiento",
      completion: "Entrega",
      viewDetails: "Ver detalles",
      noResults: "No hay propiedades"
    },
    services: {
      overline: "Servicios Exclusivos",
      title: "Conserjería de Lujo",
      subtitle: "Una gama completa de servicios premium para una experiencia inolvidable en Bali.",
      items: {
        vip: {
          title: "Traslados VIP y Helicóptero",
          description: "Recepción en aeropuerto, conductor privado y traslados en helicóptero."
        },
        villa: {
          title: "Gestión de Villas",
          description: "Servicio completo de gestión de alquileres y mantenimiento para su propiedad."
        },
        chef: {
          title: "Chef Privado y Wellness",
          description: "Experiencias culinarias a medida y tratamientos de spa a domicilio."
        },
        yacht: {
          title: "Yate y Excursiones",
          description: "Alquiler de yates privados y planificación de excursiones exclusivas."
        }
      }
    },
    journey: {
      overline: "Su Viaje",
      title: "Cómo Funciona",
      steps: {
        consultation: {
          title: "Consulta",
          description: "Definimos sus objetivos de inversión y necesidades de estilo de vida."
        },
        selection: {
          title: "Selección",
          description: "Cartera de propiedades que coinciden con sus criterios."
        },
        acquisition: {
          title: "Adquisición",
          description: "Gestión completa de la transacción hasta la entrega."
        },
        handover: {
          title: "Gestión",
          description: "Servicios de conserjería y gestión de alquileres incluidos."
        }
      }
    },
    testimonials: {
      overline: "Testimonios",
      title: "Lo Que Dicen Nuestros Clientes",
      items: {
        sophie: {
          role: "Inversora, París",
          text: "Apoyo excepcional de principio a fin. Mi inversión genera rendimientos superiores a las expectativas."
        },
        thomas: {
          role: "Emprendedor, Lyon",
          text: "Profesionalismo y experiencia notables. Bali Life hizo mi compra simple y segura."
        },
        marie: {
          role: "Expat, Singapur",
          text: "La calidad de los servicios de conserjería es incomparable. Un equipo verdaderamente dedicado."
        }
      }
    },
    contact: {
      overline: "Empezar",
      title: "Hablemos de Su Proyecto",
      subtitle: "Nuestro equipo de expertos está disponible para responder todas sus preguntas sobre invertir en Bali.",
      info: {
        address: { title: "Dirección" },
        phone: { title: "Teléfono" },
        email: { title: "Email" }
      },
      form: {
        name: "Nombre completo",
        namePlaceholder: "Su nombre",
        email: "Email",
        emailPlaceholder: "usted@email.com",
        phone: "Teléfono",
        phonePlaceholder: "+34 612 345 678",
        message: "Mensaje",
        messagePlaceholder: "¿Cómo podemos ayudarle?",
        send: "Enviar",
        sending: "Enviando..."
      },
      success: {
        title: "¡Mensaje Enviado!",
        message: "Nuestro equipo le contactará en 24h."
      }
    },
    footer: {
      description: "Su socio de confianza para inversión inmobiliaria y servicios de conserjería de lujo en Bali.",
      quickLinks: "Navegación",
      followUs: "Síguenos",
      rights: "Todos los derechos reservados."
    },
    chatbot: {
      title: "Concierge IA",
      subtitle: "En línea 24/7",
      welcome: "¡Hola! Soy su concierge IA. ¿Cómo puedo ayudarle con su inversión o estancia en Bali?",
      placeholder: "Escriba su mensaje...",
      error: "Lo siento, ocurrió un error. Por favor, inténtelo de nuevo."
    }
  }
};

export const languageNames = {
  fr: "Français",
  en: "English",
  id: "Indonesia",
  es: "Español"
};

export const languageFlags = {
  fr: "🇫🇷",
  en: "🇬🇧",
  id: "🇮🇩",
  es: "🇪🇸"
};
